import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "fields", "field"]

  connect() {
    this.updateFields()
  }

  toggle() {
    this.updateFields()
  }

  updateFields() {
    const enabled = this.toggleTarget.checked

    this.fieldsTarget.classList.toggle("hidden", !enabled)
    this.fieldsTarget.setAttribute("aria-hidden", String(!enabled))
    this.toggleTarget.setAttribute("aria-expanded", String(enabled))

    this.fieldTargets.forEach((field) => {
      field.disabled = !enabled
      field.required = enabled && field.dataset.required === "true"
    })
  }
}
